import React, { useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import QRCodeGenerator from "../utils/createQRcode";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useSelector } from "react-redux";

const GenerateQRCodeScreen = () => {
  const location = window.location.origin;
  const { userInfo } = useSelector((state) => state.auth);
  // console.log("location");
  // console.log(origin);
  const [screenName, setScreenName] = useState("");
  const [startAlpha, setStartAlpha] = useState("");
  const [endAlpha, setEndAlpha] = useState("");
  const [startSeat, setStartSeat] = useState("");
  const [endSeat, setEndSeat] = useState("");
  const [showSeatDetails, setShowSeatDetails] = useState(true);
  const [qrCodes, setQrCodes] = useState([]);
  const navigate = useNavigate();

  const generateSeatRange = (startChar, endChar, startNum, endNum) => {
    const seatList = [];
    for (
      let row = startChar.charCodeAt(0);
      row <= endChar.charCodeAt(0);
      row++
    ) {
      for (let seat = parseInt(startNum); seat <= parseInt(endNum); seat++) {
        const seatId = `${String.fromCharCode(row)}${seat}`;
        seatList.push(seatId);
      }
    }
    return seatList;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const seats = generateSeatRange(
      startAlpha.toUpperCase(),
      endAlpha.toUpperCase(),
      startSeat,
      endSeat
    );

    const generatedQRCodes = seats.map((seat) => {
      const label = `${screenName} - ${seat}`;
      const qrData = showSeatDetails
        ? `https://fcustomers.gymfort.in/${userInfo?.selectedOutletId}-${screenName}-${seat}`
        : `https://fcustomers.gymfort.in/${userInfo?.selectedOutletId}`;
      return { seatLabel: label, qrValue: qrData };
    });

    setQrCodes(generatedQRCodes);
  };

  const qrRef = useRef(null);

  const handleDownloadPDF = async () => {
    // console.log(qrRef.current);
    if (!qrRef.current) return;

    const canvas = await html2canvas(qrRef.current, { scale: 4 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "pt", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgProps = pdf.getImageProperties(imgData);
    const imgWidth = pageWidth;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

    pdf.save("qr_codes.pdf");
  };

  const handleBack = () => {
    navigate("/");
  };
  return (
    <>
      <Button onClick={handleBack}>Back</Button>
      &nbsp;
      <h5>Outlet QR Code</h5>
      <Card
        style={{
          backgroundColor: "#ffffff",
          padding: "1rem",
          margin: "0.5rem",
          minWidth: "12rem",
          width: "30%",
          borderRadius: "8px",
          textAlign: "center",
        }}
      >
        <QRCodeGenerator
          content={`https://fcustomers.gymfort.in/${userInfo?.selectedOutletId}`}
          bgColor="#fff"
          fgColor="#000"
        />
      </Card>
      <br />
      <br />
      <br />
      <h5>Create Multiple QR Codes</h5>
      <Row className="justify-content-center">
        <Col md={6}>
          <label style={{ color: "red" }}>
            {" "}
            * only maximum of 50 QR codes can be downloaded at a time
          </label>
          <br /> <br />
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="qrInput">
              <Row className="mb-3">
                <Col>
                  <Form.Control
                    type="text"
                    placeholder="Enter Screen Name"
                    value={screenName}
                    onChange={(e) => setScreenName(e.target.value)}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Row className="mb-3">
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Starting Alphabet"
                  value={startAlpha}
                  onChange={(e) => setStartAlpha(e.target.value)}
                  maxLength={1}
                  required
                />
              </Col>
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Ending Alphabet"
                  value={endAlpha}
                  onChange={(e) => setEndAlpha(e.target.value)}
                  maxLength={1}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Control
                  type="number"
                  placeholder="Starting Seat Number"
                  value={startSeat}
                  onChange={(e) => setStartSeat(e.target.value)}
                  required
                />
              </Col>
              <Col>
                <Form.Control
                  type="number"
                  placeholder="Ending Seat Number"
                  value={endSeat}
                  onChange={(e) => setEndSeat(e.target.value)}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3 align-items-center">
              <Col xs={6}>
                <label>Display Seat number details in QR code?</label>
              </Col>
              <Col xs={3}>
                <Form.Check
                  type="radio"
                  label="Yes"
                  checked={showSeatDetails}
                  onChange={() => setShowSeatDetails(true)}
                />
              </Col>
              <Col xs={3}>
                <Form.Check
                  type="radio"
                  label="No"
                  checked={!showSeatDetails}
                  onChange={() => setShowSeatDetails(false)}
                />
              </Col>
            </Row>
            <Row className="text-center">
              <Col>
                <Button type="submit" variant="success">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      {qrCodes.length > 0 && (
        <>
          <hr />
          <Row className="text-center mb-2">
            <Col>
              <Button variant="success" onClick={handleDownloadPDF}>
                Download
              </Button>{" "}
              {/* Add download logic if needed */}
            </Col>
          </Row>
          <Row
            ref={qrRef}
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(15rem, 1fr))",
              gap: "1rem",
              padding: "1.5rem",
              backgroundColor: "#fff",
              borderRadius: "10px",
              justifyItems: "center", // center items inside grid cells
            }}
          >
            {qrCodes.map(({ seatLabel, qrValue }, idx) => (
              <Card
                key={idx}
                style={{
                  backgroundColor: "#ffffff",
                  padding: "1rem",
                  margin: "0.5rem",
                  minWidth: "12rem",
                  width: "100%",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                Scan to Order
                <br /> <br />
                <Row>
                  <Col md={7}>
                    <QRCodeGenerator
                      content={qrValue}
                      bgColor="#fff"
                      fgColor="#000"
                    />
                    {/* <br /> */}
                    <br />
                    <label>{seatLabel}</label>
                  </Col>{" "}
                  <Col
                    md={5}
                    style={{
                      fontSize: "0.75rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <p>{"zpotter technologies"}</p>
                  </Col>
                  {/* <br />
                  <p style={{ fontSize: "0.2rem" }}>
                    powered by <br />
                    zpotter technologies
                  </p> */}
                </Row>
              </Card>
            ))}
          </Row>
        </>
      )}
    </>
  );
};

export default GenerateQRCodeScreen;
